import React from 'react';
import './loading.css'; 
const Loadingimg = () => {
  return (
    <div  className="loding-body" > 
    </div> 
  );
};
export default Loadingimg;
